import styled from "styled-components";
import React from "react";

function AddressComponent({address, addressee}) {
  return (
    <AddressContainer>
      {<AddressLineBold>{addressee}</AddressLineBold>}
      {address.address && (
        <AddressLine>
          {address.address}, {address.addressLine2 ? `${address.addressLine2},` : null}
        </AddressLine>
      )}
      {address.city && address.state && address.zipCode && (
        <AddressLine>
          {address.city}, {address.state} {address.zipCode}
        </AddressLine>
      )}
    </AddressContainer>
  );
}

const AddressContainer = styled.div``;

const AddressLine = styled.div`
  text-align: center;
  font-size: ${({theme}) => theme.v2.typography.sizing.m.lg};
  margin-top: 2px;
`;

const AddressLineBold = styled(AddressLine)`
  font-weight: ${({theme}) => theme.v2.typography.bodyText1.weight.heavy};
`;

export default AddressComponent;
